import { getEndpoint } from "../utils/stringUtil";
import client from "./axios";

export interface TutorialVideo {
  id: number;
  path: string;
  parentId: number;
  title: string;
  description: string | null;
  signedUrl?: string;
  createdAt?: string;
}

const base = `${getEndpoint()}api/videos`;

export const Video = {
  list: () => client.get<{ list: TutorialVideo[] }>(base),
  create: (formData: FormData) =>
    client.post<{ video: TutorialVideo }>(base, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  update: (id: number, body: { title?: string; description?: string }) =>
    client.put<{ video: TutorialVideo }>(`${base}/${id}`, body),
  remove: (id: number) => client.delete(`${base}/${id}`),
};
